import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PurchaseOrderContext } from '../../purchase-order/context/PurchaseOrderContext';
import { useGetCreditMemo } from '../api/get-credit-memo';
import { POCreditMemoContext } from '../context/POCreditMemoContext';
import { POCreditMemoContextType } from '../types/POCreditMemoContextType';
import { POCreditMemoProduct } from '../types/POCreditMemoProduct';

export default function POCreditMemoPage(props: React.PropsWithChildren<unknown>) {

	const { order } = useContext(PurchaseOrderContext);

	const params = useParams();
	const creditMemoID = params.creditMemoID ? parseInt(params.creditMemoID) : undefined;

	const { data: creditMemoData } = useGetCreditMemo(creditMemoID);

	const [creditMemo, setCreditMemo] = useState<POCreditMemoContextType>(
		{
			details: {
				purchaseOrderID: order.details.purchaseOrderID,
				poNumber: order.details.poNumber,
				products: params.creditMemoID ? [] :
					order.details.products.map((x, index) => {
						return {
							creditMemoProductID: -index - 1,
							poProductID: x.poProductID,
							productID: x.productID,
							productDescription: x.itemDescription,
							sku: x.sku,
							shippedDate: x.shippedDate,
							quantity: 0,
							price: 0,
							amount: 0
						} as POCreditMemoProduct
					}),
			}
		}
	);

	useEffect(() => {
		if (creditMemoData) {
			setCreditMemo({ details: creditMemoData });
		}
	}, [creditMemoData]);

	return (
		<React.Fragment>
			{
				creditMemo.details &&
				<POCreditMemoContext.Provider value={{
					creditMemo: creditMemo,
					modify: (details) => setCreditMemo({ details: details })
				}}>
					{props.children}
				</POCreditMemoContext.Provider>
			}
		</React.Fragment>)
}
